var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaboratoryTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_19_",
    x: 42,
    y: 54,
    fill: "none",
    width: 26,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_20_",
    x: 190,
    y: 117,
    fill: "none",
    width: 26,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_21_",
    x: 116,
    y: 54,
    fill: "none",
    width: 26,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_22_",
    x: 190,
    y: 54,
    fill: "none",
    width: 26,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_23_",
    x: 42,
    y: 117,
    fill: "none",
    width: 26,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    fill: "none",
    d: "M241,117h-13v59c0,13.7-11.3,24.8-25,24.8c-13.7,0-25-11.1-25-24.8v-59h-24v59 c0,13.7-11.3,24.8-25,24.8c-13.7,0-25-11.1-25-24.8v-59H80v59c0,13.7-11.3,24.8-25,24.8c-13.7,0-25-11.1-25-24.8v-59H16v106h225 V117z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    d: "M252,223L252,223V106h-24V54h8V39h-65v15h7v52h-24V54h8V39H97v15h7v52H80V54h8V39H23v15h7v52H5v117l0,0v12 h37v16h23v-16h128v16h23v-16h36V223z M190,54h26v52h-26V54z M216,126h-26v-9h26V126z M142,54v23h-26V54H142z M42,54h26v52H42V54z  M68,148H42v-31h26V148z M16,117h14v59c0,13.7,11.3,24.8,25,24.8c13.7,0,25-11.1,25-24.8v-59h24v59c0,13.7,11.3,24.8,25,24.8 c13.7,0,25-11.1,25-24.8v-59h24v59c0,13.7,11.3,24.8,25,24.8c13.7,0,25-11.1,25-24.8v-59h13v106H16V117z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratoryTools);
export default __webpack_public_path__ + "static/media/laboratory-tools.2dd923859377c0565f1902796f89602c.svg";
export { ForwardRef as ReactComponent };